module.exports = __webpack_public_path__ + "static/media/DWK_02.6476d7b4.jpg";